<template>
    <picture class="component-image">
        <source
            v-for="(item, key) in sources"
            :key="key"
            :srcset="getSrcset(item.srcset)"
            :type="item.mimeType"
            :width
            :height
            :sizes="sizes ? parseSizes(sizes) : item.sizes"
        />

        <img
            ref="imageElement"
            :alt="alt || undefined"
            :class="classImage"
            :width
            :height
            :loading
            :fetchpriority
            :src
            class="image"
            @error="$emit('error')"
            @load="$emit('load')"
        />
    </picture>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { type ImageSizes, parseSizes } from '@/components/getImageProps.ts'

type Srcset = string[] | string

export type ImageProps = {
    src: string
    width?: number
    height?: number
    fit?: 'contain' | 'cover' | undefined
    loading?: 'lazy' | 'eager'
    fetchpriority?: 'high' | 'auto' | 'low'
    alt?: string | null
    sources?: {
        srcset: Srcset
        mimeType: string
        sizes?: string
    }[]
    sizes?: ImageSizes
}

const props = defineProps<ImageProps>()

const imageElement = ref<HTMLImageElement | null>(null)

const emit = defineEmits<{
    load: []
    error: []
}>()

onMounted(() => {
    if (imageElement.value?.complete) {
        emit('load')
    }
})

const getSrcset = (srcset: Srcset) =>
    Array.isArray(srcset) ? srcset.join(', ') : srcset

const classImage = computed(() => {
    if (!props.fit) {
        return {}
    }

    return {
        [props.fit]: true,
    }
})
</script>

<style lang="scss" scoped>
.component-image {
    width: 100%;
    height: 100%;
    line-height: 0;
    display: block;

    .image {
        width: 100%;
        height: 100%;

        &.cover {
            object-fit: cover;
        }

        &.contain {
            object-fit: contain;
            object-position: center center;
        }
    }
}
</style>
